<template>
  <b-container>
    <ProfileHero :artist="artist" />
    <ArtistProfileTabs :artist="artist" />

    <b-row>
      <b-col>
        <b-form-group :label="reportLabel">
          <b-form-select v-model="reason" :options="reasonOptions" size="sm" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button class="btn-rainbow" @click="send" :disabled="!reason">Report</b-button>
      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  img.avatar {  }
</style>

<script>
import ArtistProfileTabs from '@/components/widgets/ArtistProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'

import { reportReasons } from '@/store/modules/tag'

export default {
  name: 'SendMessage',
  components: {
    ArtistProfileTabs,
    ProfileHero
  },
  data () {
    return {
      artist: null,
      reason: null
    }
  },
  computed: {
    reasonOptions () {
      return reportReasons
    },
    reportLabel () {
      if (!this.artist || !this.artist.name) return 'Report Artist'
      return 'Report ' + this.artist.name
    }
  },
  watch: {
    '$route': 'initPage'
  },
  created () {
    this.initPage()
  },
  methods: {
    async initPage () {
      if (this.currentArtist && this.$route.params.artistId === this.currentArtist.id) {
        this.$router.push({name: 'artist-messages'})
        return
      }

      this.artist = await this.$store.dispatch('artist/getArtist', { id: this.$route.params.artistId })
    },
    async send () {
      if (!this.reason) return

      this.working = true
      await this.$store.dispatch('artist/reportArtist', {
        id: this.artist.id,
        reason: this.reason,
        url: this.$route.fullPath
      })
      this.working = false

      this.$store.dispatch('flash/showMessage', {message: 'Thank you for reporting this'})
      this.$router.push({name: 'artist-about', params: { artistId: this.$route.params.artistId }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/ReportArtist.vue